<section class="comminsoon-pg-area">

    <div class="container">
        <div  class="row justify-content-center">
            <div class="col-md-8 col-12 text-center">
                <div class="comming-wht-bx">
                    <h1 class="section-heading">Coming soon</h1>
                    <p>Currently, we do not have any courses for your class. We will notify you once we are ready. Stay tuned!</p>
                    <img src="assets/img/Group 1118.png" />
                </div>
                <div class="app-wht-bx">
                    <div class="lft-txt-area">
                        <h3>Get your doubts cleared instantly.</h3>
                        <h4>Download the app now.</h4>
                    </div>
                    <div class="actn-area">
                        <a href="https://play.google.com/store/apps/details?id=com.infinitylearn.doubt" class="google-play-btn">
                            <img src="assets/img/google-play-btn.png" alt="" />
                        </a>
                    </div>
                </div>
                
            </div>
        </div>
    </div>

</section>